import React from "react";

const StepIndicator = ({ currentStep }) => {
  const steps = [
    "Receiver List",
    "Payment Information",
    "Confirm Transaction",
    "Transaction Denomination",
    "Transaction Receipt",
  ];

  return (
    <div className="d-flex align-items-center justify-content-center mb-5 mt-4 w-100 position-relative">
      <div
        className="position-absolute"
        style={{
          height: "1px",
          background: "#eee",
          width: "70%",
          top: "18px",
          zIndex: 0,
        }}
      />
      {steps.map((step, index) => {
        const stepNum = index + 1;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;

        return (
          <div
            key={index}
            className="d-flex flex-column align-items-center position-relative"
            style={{ zIndex: 1, width: "150px" }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center fw-bold fs-12 mb-2"
              style={{
                width: "36px",
                height: "36px",
                backgroundColor:
                  isActive || isCompleted ? "var(--primary)" : "#f8f9fa",
                color: isActive || isCompleted ? "#fff" : "#ccc",
                border: isActive || isCompleted ? "none" : "1px solid #eee",
              }}
            >
              {stepNum}
            </div>
            <span
              className="text-center"
              style={{
                fontSize: "12px",
                color: isActive ? "#000" : "#888",
                fontWeight: isActive ? "bold" : "normal",
                whiteSpace: "nowrap",
              }}
            >
              {step}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator;
